/**
 * Holds a reference to whichever auth provider is currently active
 * (static or dynamic). This allows the data provider and other services
 * to acquire tokens from the correct MSAL instance without needing to
 * know which auth path was taken.
 */
import { AuthProvider } from "react-admin";

let activeProvider: AuthProvider | null = null;

export const setActiveAuthProvider = (provider: AuthProvider): void => {
  activeProvider = provider;
  console.log("[ActiveAuthProvider] Active auth provider set");
};

export const getActiveAuthProvider = (): AuthProvider | null => {
  return activeProvider;
};
